﻿/**
 * Project Space - User Account & Expert Locator
 * Handles user registration, profile updates, postal code API, and expert locator
 */

document.addEventListener("DOMContentLoaded", function () {
  // =============================================================================
  // POSTAL CODE TO CITY AUTOCOMPLETE
  // =============================================================================

  const postalCodeInput = document.getElementById("postal_code");
  const cityInput = document.getElementById("city");
  const cityList = document.getElementById("city-suggestions-list");

  if (postalCodeInput && cityInput) {
    let debounceTimer;

    postalCodeInput.addEventListener("input", function () {
      clearTimeout(debounceTimer);

      const postalCode = this.value.trim();

      // Only search if we have exactly 5 digits
      if (postalCode.length !== 5 || !/^\d{5}$/.test(postalCode)) {
        if (cityList) {
          cityList.classList.add("hidden");
          cityList.innerHTML = "";
        }
        return;
      }

      debounceTimer = setTimeout(() => {
        fetchCitiesByPostalCode(postalCode);
      }, 300);
    });

    function fetchCitiesByPostalCode(postalCode) {
      const formData = new FormData();
      formData.append("action", "get_cities_by_postal_code");
      formData.append("postal_code", postalCode);

      fetch(ajax.url, {
        method: "POST",
        body: formData,
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.success && data.data.cities) {
            // Auto-fill if only one city, otherwise show dropdown
            if (data.data.cities.length === 1) {
              cityInput.value = data.data.cities[0].name;
              if (cityList) {
                cityList.classList.add("hidden");
                cityList.innerHTML = "";
              }
            } else {
              updateCitySuggestions(data.data.cities);
            }
          } else {
            if (cityList) {
              cityList.classList.add("hidden");
              cityList.innerHTML = "";
            }
          }
        })
        .catch((error) => {
          console.error("Error fetching cities:", error);
        });
    }

    function updateCitySuggestions(cities) {
      if (!cityList) return;
      cityList.innerHTML = "";

      cities.forEach((city) => {
        const li = document.createElement("li");
        li.textContent = city.name;
        li.className = "px-4 py-2 cursor-pointer hover:bg-gray-100 text-sm";
        li.addEventListener("click", function () {
          cityInput.value = city.name;
          cityList.classList.add("hidden");
        });
        cityList.appendChild(li);
      });

      cityList.classList.remove("hidden");
    }

    // Close dropdown when clicking outside
    document.addEventListener("click", function (e) {
      if (
        cityList &&
        !cityInput.contains(e.target) &&
        !cityList.contains(e.target)
      ) {
        cityList.classList.add("hidden");
      }
    });
  }

  // =============================================================================
  // USER ACCOUNT FORM SUBMISSION
  // =============================================================================

  const accountForm = document.getElementById("user-account-form");
  const accountMessages = document.getElementById("account-messages");

  if (accountForm) {
    accountForm.addEventListener("submit", function (e) {
      e.preventDefault();

      // Clear previous messages
      showMessage("", "info", true);

      // Get form data
      const formData = new FormData(accountForm);

      // Validate RGPD consent for registration
      const rgpdCheckbox = accountForm.querySelector("#rgpd_consent");
      if (rgpdCheckbox && !rgpdCheckbox.checked) {
        showMessage(
          "Veuillez accepter notre politique de gestion des données personnelles pour continuer.",
          "error",
        );
        return;
      }

      // Validate required address / location fields
      const addrField = accountForm.querySelector("#address");
      const postalField = accountForm.querySelector("#postal_code");
      const cityField = accountForm.querySelector("#city");
      if (addrField && !addrField.value.trim()) {
        showMessage("Veuillez renseigner votre adresse.", "error");
        return;
      }
      if (postalField && !postalField.value.trim()) {
        showMessage("Veuillez renseigner votre code postal.", "error");
        return;
      }
      if (cityField && !cityField.value.trim()) {
        showMessage("Veuillez renseigner votre ville.", "error");
        return;
      }

      // Validate password match for registration
      const password = formData.get("password");
      const passwordConfirm = formData.get("password_confirm");

      if (password && password !== passwordConfirm) {
        showMessage("Les mots de passe ne correspondent pas.", "error");
        return;
      }

      // Show loading state
      const submitButton = accountForm.querySelector('button[type="submit"]');
      const originalButtonText = submitButton.innerHTML;
      submitButton.disabled = true;
      submitButton.innerHTML =
        '<span class="inline-block animate-spin mr-2"><svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.5459 0V1.11564H12.9639V4.90499L12.7119 5.07124L8.30371 8.00024L12.7119 10.9292L12.9639 11.0955V14.8848H14.5459V16.0005H0V14.8848H1.58203V11.0955L1.83301 10.9292L6.24023 8.00024L1.83301 5.07124L1.58203 4.90499V1.11564H0V0H14.5459ZM2.78223 11.6697V14.8848H11.7637V11.6706L7.27246 8.68616L2.78223 11.6697ZM2.78223 4.32991L7.27246 7.31342L11.7637 4.329V1.11564H2.78223V4.32991Z" fill="white"/></svg></span> Enregistrement...';

      // Submit form via AJAX
      fetch(ajax.url, {
        method: "POST",
        body: formData,
      })
        .then((response) => response.json())
        .then((data) => {
          submitButton.disabled = false;
          submitButton.innerHTML = originalButtonText;

          if (data.success) {
            showMessage(
              data.data.message ||
                "Vos informations ont été enregistrées avec succès.",
              "success",
            );

            // Redirect if specified
            if (data.data.redirect) {
              setTimeout(() => {
                window.location.href = data.data.redirect;
              }, 1500);
            } else {
              // Redirect back to informations tab (preserves tab context)
              setTimeout(() => {
                var url = new URL(window.location.href);
                url.searchParams.set("active_tab", "informations");
                url.searchParams.delete("garantie_status");
                window.location.href = url.toString();
              }, 1500);
            }
          } else {
            // Handle errors
            let errorMessage = "Une erreur est survenue.";

            if (
              data.data &&
              data.data.messages &&
              Array.isArray(data.data.messages)
            ) {
              errorMessage = '<ul class="list-disc pl-5">';
              data.data.messages.forEach((msg) => {
                errorMessage += `<li>${msg}</li>`;
              });
              errorMessage += "</ul>";
            } else if (data.data && data.data.message) {
              errorMessage = data.data.message;
            }

            showMessage(errorMessage, "error");
          }
        })
        .catch((error) => {
          console.error("Error:", error);
          submitButton.disabled = false;
          submitButton.innerHTML = originalButtonText;
          showMessage(
            "Une erreur réseau est survenue. Veuillez réessayer.",
            "error",
          );
        });
    });
  }

  // =============================================================================
  // ACCOUNT DELETION
  // =============================================================================

  const deleteAccountBtn = document.getElementById("delete-account-btn");
  const deleteAccountModal = document.getElementById("delete-account-modal");
  const cancelDeleteBtn = document.getElementById("cancel-delete-btn");
  const confirmDeleteBtn = document.getElementById("confirm-delete-btn");

  if (deleteAccountBtn && deleteAccountModal) {
    deleteAccountBtn.addEventListener("click", function () {
      deleteAccountModal.classList.remove("hidden");
      deleteAccountModal.classList.add("flex");
    });

    cancelDeleteBtn?.addEventListener("click", function () {
      deleteAccountModal.classList.add("hidden");
      deleteAccountModal.classList.remove("flex");
    });

    confirmDeleteBtn?.addEventListener("click", function () {
      const formData = new FormData();
      formData.append("action", "delete_user_account");
      formData.append(
        "nonce",
        document.querySelector('input[name="nonce"]')?.value || "",
      );

      confirmDeleteBtn.disabled = true;
      confirmDeleteBtn.textContent = "Suppression...";

      fetch(ajax.url, {
        method: "POST",
        body: formData,
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.success) {
            alert(
              data.data.message ||
                "Votre compte a Ã©tÃ© supprimÃ© avec succÃ¨s.",
            );
            if (data.data.redirect) {
              window.location.href = data.data.redirect;
            } else {
              window.location.href = "/";
            }
          } else {
            alert(data.data.message || "Une erreur est survenue.");
            confirmDeleteBtn.disabled = false;
            confirmDeleteBtn.textContent = "Supprimer";
          }
        })
        .catch((error) => {
          console.error("Error:", error);
          alert("Une erreur rÃ©seau est survenue.");
          confirmDeleteBtn.disabled = false;
          confirmDeleteBtn.textContent = "Supprimer";
        });
    });

    // Close modal on backdrop click
    deleteAccountModal.addEventListener("click", function (e) {
      if (e.target === deleteAccountModal) {
        deleteAccountModal.classList.add("hidden");
        deleteAccountModal.classList.remove("flex");
      }
    });
  }

  // =============================================================================
  // UTILITY FUNCTIONS
  // =============================================================================

  function showMessage(message, type = "info", hide = false) {
    if (!accountMessages) return;

    if (hide) {
      accountMessages.classList.add("hidden");
      accountMessages.innerHTML = "";
      return;
    }

    const colorClasses = {
      success: "bg-green-100 border-green-400 text-green-700",
      error: "bg-red-100 border-red-400 text-red-700",
      info: "bg-blue-100 border-blue-400 text-blue-700",
    };

    accountMessages.className = `mb-6 p-4 border-l-4 ${colorClasses[type] || colorClasses.info}`;
    accountMessages.innerHTML = message;
    accountMessages.classList.remove("hidden");

    // Scroll to message
    accountMessages.scrollIntoView({ behavior: "smooth", block: "nearest" });
  }

  // =============================================================================
  // PASSWORD STRENGTH INDICATOR (Optional Enhancement)
  // =============================================================================

  const passwordInput = document.getElementById("password");

  if (passwordInput) {
    passwordInput.addEventListener("input", function () {
      const password = this.value;
      let strength = 0;

      if (password.length >= 8) strength++;
      if (password.match(/[a-z]/) && password.match(/[A-Z]/)) strength++;
      if (password.match(/\d/)) strength++;
      if (password.match(/[^a-zA-Z\d]/)) strength++;

      // You can add a visual strength indicator here if needed
    });
  }
});

// Tab switching functionality
document.addEventListener("DOMContentLoaded", function () {
  const tabButtons = document.querySelectorAll(".tab-button");
  const tabContents = document.querySelectorAll(".tab-content");

  tabButtons.forEach((button) => {
    button.addEventListener("click", function () {
      if (this.disabled) return;

      const tabName = this.dataset.tab;

      // Désactiver tous les onglets : effacer fond + restaurer couleur icône
      tabButtons.forEach((btn) => {
        btn.classList.remove("text-white");
        btn.classList.add("text-grey-darker");
        btn.style.backgroundColor = "";
        btn.setAttribute("aria-selected", "false");

        const icon = btn.querySelector(".tab-icon");
        if (icon && btn.dataset.iconColor) {
          icon.classList.remove("text-white");
          icon.style.color = btn.dataset.iconColor;
        }
      });

      // Activer l'onglet cliqué : fond alterné via data-active-bg
      this.classList.remove("text-grey-darker");
      this.classList.add("text-white");
      this.style.backgroundColor = this.dataset.activeBg || "#E89885";
      this.setAttribute("aria-selected", "true");

      // Make icon white for active tab
      const activeIcon = this.querySelector(".tab-icon");
      if (activeIcon) {
        activeIcon.style.color = "";
        activeIcon.classList.add("text-white");
      }

      // Hide all tab contents
      tabContents.forEach((content) => {
        content.classList.add("hidden");
      });

      // Show selected tab content
      const selectedTab = document.getElementById("tab-" + tabName);
      if (selectedTab) {
        selectedTab.classList.remove("hidden");
      }

      // Chargement à la demande pour l'onglet configurations
      if (
        tabName === "configurations" &&
        typeof window.loadConfigurations === "function"
      ) {
        window.loadConfigurations();
      }
    });
  });

  // Chargement immédiat si l'onglet configurations est actif au chargement
  const configTabActive = document.querySelector(
    '.tab-button[data-tab="configurations"][aria-selected="true"]',
  );
  if (configTabActive && typeof window.loadConfigurations === "function") {
    window.loadConfigurations();
  }
});

/**
 * =============================================================================
 * FORMULAIRE DE GARANTIE (jQuery)
 * Navigation entre les étapes, validation, autocomplete villes, sliders NPS
 * =============================================================================
 */
jQuery(document).ready(function ($) {
  // =====================================================
  // PRELOADER
  // =====================================================
  setTimeout(function () {
    $("#preloader").addClass("hidden");
  }, 2000);

  // =====================================================
  // NAVIGATION ENTRE LES TABS DE GARANTIE
  // =====================================================

  // Navigation Next/Previous
  $(".btnNext").on("click", function (e) {
    e.preventDefault();
    const nextPage = $(this).data("nextpage");

    if (!$(this).hasClass("opacity-50") && !$(this).attr("disabled")) {
      showGarantieTab(nextPage);
    } else {
      alert("Veuillez remplir tous les champs obligatoires avant de continuer");
    }
  });

  $(".btnPrevious").on("click", function (e) {
    e.preventDefault();
    const prevPage = $(this).data("prevpage");
    showGarantieTab(prevPage);
  });

  // Click sur les tabs de navigation
  $(".garantie-tab-link").on("click", function (e) {
    e.preventDefault();
    if (!$(this).hasClass("garantie-tab-disabled")) {
      const tabNum = $(this).data("tab");
      showGarantieTab(tabNum);
    }
  });

  function showGarantieTab(tabNumber) {
    // Hide all tabs
    $(".garantie-tab-pane").addClass("hidden");

    // Show selected tab
    $("#garantie-tab" + tabNumber).removeClass("hidden");

    // Update navigation links
    $(".garantie-tab-link")
      .removeClass("active bg-secondary text-white")
      .addClass("bg-gray-200 text-gray-600");
    $('.garantie-tab-link[data-tab="' + tabNumber + '"]')
      .removeClass("bg-gray-200 text-gray-600")
      .addClass("active bg-secondary text-white");
  }

  // =====================================================
  // VALIDATION DU FORMULAIRE D'ENREGISTREMENT (TAB 4)
  // =====================================================

  function validateEnregistrementForm() {
    let allFilled = true;

    // Check all required fields in tab 4
    $("#garantie-tab4 input[required], #garantie-tab4 select[required]").each(
      function () {
        if (
          $(this).attr("type") === "radio" ||
          $(this).attr("type") === "checkbox"
        ) {
          const name = $(this).attr("name");
          if ($('input[name="' + name + '"]:checked').length === 0) {
            allFilled = false;
            return false;
          }
        } else {
          if ($(this).val() === "" || $(this).val() === null) {
            allFilled = false;
            return false;
          }
        }
      },
    );

    const $button = $("#garantie_button_disabled");
    if (allFilled) {
      $button
        .removeClass("opacity-50 cursor-not-allowed")
        .removeAttr("disabled");
      $(".garantie-tab-disabled").removeClass("hidden");
    } else {
      $button
        .addClass("opacity-50 cursor-not-allowed")
        .attr("disabled", "disabled");
      $(".garantie-tab-disabled").addClass("hidden");
    }
  }

  // Listen to changes on all inputs in tab 4
  $("#garantie-tab4 input, #garantie-tab4 select").on(
    "change input",
    function () {
      validateEnregistrementForm();
      updateSummaryTable();
    },
  );

  // =====================================================
  // SUGGESTION DE VILLES (API VICOPO)
  // =====================================================

  const postalCodeInput = $("#garantie_code_postal");
  const cityInput = $("#garantie_client_city");
  const citySuggest = $("#garantie-city-suggest");

  function showCitySuggestions(cities, inputLength) {
    citySuggest.empty().removeClass("hidden");

    const maxResults =
      inputLength < 4 ? Math.min(cities.length, 10) : cities.length;

    for (let i = 0; i < maxResults; i++) {
      if (cities[i].code !== "00000" && cities[i].city !== "ERREUR") {
        const $li = $(
          '<li class="px-4 py-2 hover:bg-gray-100 cursor-pointer text-sm">',
        )
          .text(cities[i].code + " - " + cities[i].city)
          .data("code", cities[i].code)
          .data("city", cities[i].city);

        citySuggest.append($li);
      }
    }

    // Click sur une suggestion
    citySuggest.find("li").on("click", function () {
      const code = $(this).data("code");
      const city = $(this).data("city");

      postalCodeInput.val(code).trigger("change");
      cityInput.val(city).trigger("change");
      citySuggest.empty().addClass("hidden");
    });
  }

  // Postal code input
  postalCodeInput.on("input", async function () {
    const value = $(this).val();

    if (value.length >= 2) {
      try {
        const response = await fetch(
          `https://vicopo.selfbuild.fr/?code=${value}`,
        );
        const data = await response.json();

        if (data.cities && data.cities.length > 0) {
          showCitySuggestions(data.cities, value.length);
        } else {
          citySuggest.empty().addClass("hidden");
        }
      } catch (error) {
        console.error("Erreur lors de la rÃ©cupÃ©ration des villes:", error);
      }
    } else {
      citySuggest.empty().addClass("hidden");
    }
  });

  // City input
  cityInput.on("input", async function () {
    const value = $(this).val();

    if (value.length >= 2) {
      try {
        const response = await fetch(
          `https://vicopo.selfbuild.fr/?city=${value}`,
        );
        const data = await response.json();

        if (data.cities && data.cities.length > 0) {
          showCitySuggestions(data.cities, value.length);
        } else {
          citySuggest.empty().addClass("hidden");
        }
      } catch (error) {
        console.error("Erreur lors de la rÃ©cupÃ©ration des villes:", error);
      }
    } else {
      citySuggest.empty().addClass("hidden");
    }
  });

  // Hide suggestions when clicking outside
  $(document).on("click", function (e) {
    if (
      !$(e.target).closest(
        "#garantie_code_postal, #garantie_client_city, #garantie-city-suggest",
      ).length
    ) {
      citySuggest.empty().addClass("hidden");
    }
  });

  // =====================================================
  // SLIDERS POUR LES NOTES (NPS)
  // =====================================================

  function updateSliderDisplay(slider, valueDisplay) {
    const value = $(slider).val();
    $(valueDisplay).text(value + "/10");

    // Changer la couleur du slider selon la valeur
    const percent = (value / 10) * 100;
    $(slider).css(
      "background",
      `linear-gradient(to right, #189D95 0%, #189D95 ${percent}%, #E5E5E5 ${percent}%, #E5E5E5 100%)`,
    );
  }

  // Écoute input ET change pour compatibilité cross-browser (certains navigateurs
  // ne déclenchent "input" qu'au mouseup sur les sliders stylisés via appearance-none)
  const sliderMap = [
    ["#note_accueil_commercial", "#note_accueil_value"],
    ["#note_produits", "#note_produits_value"],
    ["#note_prix", "#note_prix_value"],
    ["#note_pose", "#note_pose_value"],
    ["#note_suivi_technique_livraison", "#note_suivi_value"],
    ["#note_rendu_final", "#note_rendu_value"],
    ["#will_recomend_poser", "#will_recomend_poser_value"],
    ["#will_recomend_product", "#will_recomend_product_value"],
  ];

  sliderMap.forEach(function ([sliderId, displayId]) {
    $(sliderId).on("input change", function () {
      updateSliderDisplay(this, displayId);
    });
  });

  // Initialize slider displays au chargement
  sliderMap.forEach(function ([sliderId, displayId]) {
    const el = $(sliderId)[0];
    if (el) updateSliderDisplay(el, displayId);
  });

  // Ré-initialiser les sliders quand tab 5 (Avis) devient visible
  // (le gradient CSS ne se calcule pas correctement sur un élément caché)
  $(document).on(
    "click",
    ".btnNext[data-nextpage='5'], .garantie-tab-link[data-tab='5']",
    function () {
      setTimeout(function () {
        sliderMap.forEach(function ([sliderId, displayId]) {
          const el = $(sliderId)[0];
          if (el) updateSliderDisplay(el, displayId);
        });
      }, 50);
    },
  );

  // =====================================================
  // MISE À JOUR DU TABLEAU RÉCAPITULATIF (TAB 6)
  // =====================================================

  function updateSummaryTable() {
    // Personal info
    $("#summary_civility").text(
      $('input[name="civility"]:checked').val() || "",
    );
    $("#summary_first_name").text($("#garantie_first_name").val());
    $("#summary_last_name").text($("#garantie_last_name").val());
    $("#summary_email").text($("#garantie_client_email").val());
    $("#summary_phone").text($("#garantie_phone").val());
    $("#summary_address").text($("#garantie_address").val());
    $("#summary_postal_code").text($("#garantie_code_postal").val());
    $("#summary_city").text($("#garantie_client_city").val());

    // Product info
    $("#summary_type_house").text(
      $('input[name="type_house"]:checked').val() || "",
    );
    $("#summary_type_window").text(
      $('input[name="type_window_changed"]:checked').val() || "Non renseigné",
    );
    $("#summary_type_door").text(
      $('input[name="type_door_changed"]:checked').val() || "Non renseigné",
    );
    $("#summary_type_volet").text(
      $('input[name="type_volet_changed"]:checked').val() || "Non renseigné",
    );
    $("#summary_purchase_date").text($("#purchase_date").val());
    $("#summary_purchase_total").text($("#purchase_total").val());
    $("#summary_purchase_location").text($("#purchase_location").val());

    // Avis
    $("#summary_will_recomend_poser").text($("#will_recomend_poser").val() + "/10");
    $("#summary_will_recomend_product").text($("#will_recomend_product").val() + "/10");
    var knownFrom = [];
    $('input[name="known_from[]"]:checked').each(function () { knownFrom.push($(this).val()); });
    $("#summary_known_from").text(knownFrom.length ? knownFrom.join(", ") : "Non renseigné");
    var invest = [];
    $('input[name="invest[]"]:checked').each(function () { invest.push($(this).val()); });
    $("#summary_invest").text(invest.length ? invest.join(", ") : "Non renseigné");
    $("#summary_amelioration_comment").text($("#amelioration_comment").val());
  }

  // =====================================================
  // PREVENT FORM SUBMISSION ON ENTER KEY
  // =====================================================

  $("#main_garantie_form").on("keypress", function (e) {
    if (e.keyCode === 13 && e.target.tagName !== "TEXTAREA") {
      e.preventDefault();
      return false;
    }
  });

  // =====================================================
  // DISABLE SCROLL ON NUMBER INPUTS
  // =====================================================

  $('input[type="number"]').on("mousewheel", function (e) {
    $(this).blur();
  });

  // =====================================================
  // BASCULEMENT ENTRE FORMULAIRES DE GARANTIE
  // =====================================================

  // Bouton "J'ai perdu mon carnet de garantie"
  $("#btn-show-restore-form").on("click", function (e) {
    e.preventDefault();
    $("#garantie-first-form").addClass("hidden");
    $("#garantie-restore-form").removeClass("hidden");
  });

  // Bouton "Retour" dans le formulaire de restauration
  $("#btn-back-to-first-form").on("click", function (e) {
    e.preventDefault();
    $("#garantie-restore-form").addClass("hidden");
    $("#garantie-first-form").removeClass("hidden");
  });
});

/**
 * =============================================================================
 * ACCORDÉONS DOCUTHÈQUE
 * Animation open/close avec force-reflow pour éviter le bug scrollHeight=0
 * sur WebKit mobile quand l'élément est en overflow:hidden.
 * =============================================================================
 */
(function () {
  "use strict";
  var container = document.getElementById("docu-accordions");
  if (!container) return;

  container.addEventListener("click", function (e) {
    var btn = e.target.closest(".docu-acc-toggle");
    if (!btn) return;

    var accordion = btn.closest(".docu-accordion");
    var content = accordion.querySelector(".docu-acc-content");
    var chevron = btn.querySelector(".docu-chevron");
    var isOpen = btn.dataset.open === "true";

    if (isOpen) {
      // --- Fermer ---
      btn.dataset.open = "false";
      btn.setAttribute("aria-expanded", "false");
      btn.classList.remove("bg-[rgba(40,69,72,0.1)]");
      btn.classList.add("border-b", "border-[rgba(122,127,139,0.3)]");
      // Mesure > supprime transition > fixe la hauteur > force reflow > remet transition > anime à 0
      var h = content.scrollHeight;
      content.style.transition = "none";
      content.style.overflow = "hidden";
      content.style.maxHeight = h + "px";
      void content.offsetHeight; // force reflow
      content.style.transition = "max-height 0.38s cubic-bezier(0.4,0,0.2,1)";
      requestAnimationFrame(function () {
        content.style.maxHeight = "0";
      });
      // Changer le chevron
      if (chevron) {
        chevron.className =
          "docu-chevron flex items-center justify-center w-[30px] h-[30px]";
        chevron.querySelector("path").setAttribute("stroke", "#284548");
      }
    } else {
      // --- Ouvrir ---
      btn.dataset.open = "true";
      btn.setAttribute("aria-expanded", "true");
      btn.classList.add("bg-[rgba(40,69,72,0.1)]");
      btn.classList.remove("border-b", "border-[rgba(122,127,139,0.3)]");
      // Mesure la hauteur réelle : retire max-height momentanément (évite scrollHeight=0 sur WebKit mobile)
      content.style.transition = "none";
      content.style.overflow = "hidden";
      content.style.maxHeight = "none";
      var naturalHeight = content.scrollHeight;
      content.style.maxHeight = "0";
      void content.offsetHeight; // force reflow
      content.style.transition = "max-height 0.38s cubic-bezier(0.4,0,0.2,1)";
      content.style.maxHeight = naturalHeight + "px";
      content.addEventListener(
        "transitionend",
        function done() {
          content.style.maxHeight = "none";
          content.style.overflow = "";
          content.style.transition = "";
          content.removeEventListener("transitionend", done);
        },
        {
          once: true,
        },
      );
      // Changer le chevron
      if (chevron) {
        chevron.className =
          "docu-chevron flex items-center justify-center bg-[#189d95] rounded-[2px] w-[30px] h-[30px] rotate-180";
        chevron.querySelector("path").setAttribute("stroke", "white");
      }
    }
  });
})();

/**
 * =============================================================================
 * BARRE DE NAVIGATION STICKY (mobile uniquement, < 1024px)
 * Apparaît quand la nav principale sort du viewport au scroll.
 * Couleurs de fond actif : alternance saumon (#E89885) / vert (#189D95)
 * selon l'index de l'onglet (pair = saumon, impair = vert).
 * =============================================================================
 */
(function () {
  "use strict";
  var stickyBar = document.getElementById("space-sticky-bar");
  var mainAside = document.querySelector(".space-project-accordions aside");
  var contentArea = document.querySelector(".space-project-accordions .flex-1");
  var mainTabBtns = document.querySelectorAll(".tab-button");
  var stickyTabBtns = document.querySelectorAll(".sticky-tab-btn");

  if (!stickyBar || !mainAside) return;

  // Couleurs d'icône par index (pair = saumon, impair = vert)
  var iconColors = ["#F18E72", "#189D95", "#F18E72", "#189D95", "#F18E72"];
  // Couleurs de fond de l'onglet actif (pair = saumon primary, impair = vert secondary)
  var activeBgColors = ["#E89885", "#189D95", "#E89885", "#189D95", "#E89885"];

  /**
   * Met à jour l'apparence visuelle de la barre sticky selon l'onglet actif.
   * @param {string} activeTabKey - clé data-tab de l'onglet actif
   */
  function updateStickyBar(activeTabKey) {
    var idx = 0;
    stickyTabBtns.forEach(function (btn) {
      var isActive = btn.dataset.tab === activeTabKey;
      var iconSpan = btn.querySelector("span:first-child");
      var existingLabel = btn.querySelector(".sticky-label");

      // Fond : couleur alternée sur l'onglet actif, transparent sur les autres
      btn.style.backgroundColor = isActive
        ? activeBgColors[idx] || "#E89885"
        : "";
      // Taille : l'onglet actif se rétracte sur son contenu, les autres partagent l'espace
      btn.style.flexShrink = isActive ? "0" : "";
      btn.style.width = isActive ? "auto" : "";
      btn.style.flex = isActive ? "0 0 auto" : "1 0 0";

      // Icône blanche sur l'onglet actif, couleur originale sinon
      if (iconSpan) {
        iconSpan.style.color = isActive
          ? "white"
          : iconColors[idx] || "#F18E72";
      }

      // Label texte : visible uniquement sur l'onglet actif, jamais tronqué
      if (isActive) {
        if (!existingLabel) {
          var lbl = document.createElement("span");
          lbl.className = "sticky-label";
          lbl.style.cssText =
            "color:white;font-size:12px;font-weight:700;line-height:1.5;white-space:nowrap;";
          lbl.textContent = btn.getAttribute("aria-label");
          btn.appendChild(lbl);
        }
      } else {
        if (existingLabel) existingLabel.remove();
      }
      idx++;
    });
  }

  /* --- Affichage / masquage via scroll (mobile uniquement) --- */
  var mql = window.matchMedia("(min-width: 1024px)");
  var scrollLocked = false; // vrai pendant le scroll animé post-clic sticky
  var scrollLockTimer = null;

  function checkStickyBar() {
    if (scrollLocked) return; // ne pas masquer pendant le défilement animé
    if (mql.matches) {
      stickyBar.style.display = "none";
      return;
    }
    var rect = mainAside.getBoundingClientRect();
    stickyBar.style.display = rect.bottom < 20 ? "flex" : "none";
  }
  window.addEventListener("scroll", checkStickyBar, {
    passive: true,
  });
  mql.addEventListener("change", checkStickyBar);
  checkStickyBar();

  /* --- Synchro avec les tabs principales --- */
  mainTabBtns.forEach(function (btn) {
    btn.addEventListener("click", function () {
      if (!this.disabled) updateStickyBar(this.dataset.tab);
    });
  });

  /* --- Clic sur une tab sticky : active + scroll vers le contenu --- */
  stickyTabBtns.forEach(function (btn) {
    btn.addEventListener("click", function () {
      var tabKey = this.dataset.tab;
      var mainBtn = document.querySelector(
        '.tab-button[data-tab="' + tabKey + '"]',
      );
      if (mainBtn && !mainBtn.disabled) {
        mainBtn.click();
        if (contentArea) {
          var offset = stickyBar.offsetHeight || 60;
          var top =
            contentArea.getBoundingClientRect().top +
            window.pageYOffset -
            offset -
            10;
          // Verrou : empêche checkStickyBar de masquer la barre pendant le scroll animé
          scrollLocked = true;
          clearTimeout(scrollLockTimer);
          scrollLockTimer = setTimeout(function () {
            scrollLocked = false;
            checkStickyBar();
          }, 700);
          // Smooth scroll polyfill (Safari ne supporte pas behavior:'smooth' sur window.scrollTo)
          (function (targetY, duration) {
            var startY = window.pageYOffset;
            var diff = targetY - startY;
            var startTime = null;
            function step(timestamp) {
              if (!startTime) startTime = timestamp;
              var elapsed = timestamp - startTime;
              var progress = Math.min(elapsed / duration, 1);
              // easeInOutCubic
              progress =
                progress < 0.5
                  ? 4 * progress * progress * progress
                  : 1 - Math.pow(-2 * progress + 2, 3) / 2;
              window.scrollTo(0, startY + diff * progress);
              if (elapsed < duration) requestAnimationFrame(step);
            }
            requestAnimationFrame(step);
          })(top, 500);
        }
        updateStickyBar(tabKey);
      }
    });
  });
})();
